import { css } from '@emotion/core'
import * as React from 'react'

import { Step as AuthModalStep } from 'main/components/common/AuthModal'
import { useWhitelabel } from 'main/framework'
import { Flags, useFeatureFlag } from 'main/hooks/useFeatureFlag'
import { Button, spacing } from 'main/ui'
import { AssetName } from 'main/util/asset'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../common'
import { i18nKeyPrefix } from '../../i18n'
import { StyledNativeLink } from './styles'

const PRE = `${i18nKeyPrefix}-HEADER-ANONYMOUS-LINKS`

interface IProps {
  onRequestOpenAuthModal: (initialStep: AuthModalStep) => void
}

const maybeRightMarginStyle = css`
  margin-right: ${spacing.majorScale(2)}px;
`

function AnonymousLinks(props: IProps) {
  const { onRequestOpenAuthModal } = props
  const whitelabel = useWhitelabel()
  const forceShowSignUpForInternalUse = useFeatureFlag(
    Flags.ALLOW_PARENT_TO_SIGN_UP_ON_WHITE_LABELED_SITE,
  ).enabled()
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <>
      <StyledNativeLink
        css={
          !whitelabel.showByDefaultExceptIfFalse(AssetName.SIGN_UP__HEADER) && maybeRightMarginStyle
        }
        rel={'nofollow'}
        onClick={() => onRequestOpenAuthModal('login')}
      >
        {t(`${PRE}-LOGIN`)}
      </StyledNativeLink>
      {(whitelabel.showByDefaultExceptIfFalse(AssetName.SIGN_UP__HEADER) ||
        forceShowSignUpForInternalUse) && (
        <Button
          kind="outline"
          onClick={() => onRequestOpenAuthModal('choose_role')}
          data-pendo="signUpCta"
        >
          {t(`${PRE}-SIGNUP`)}
        </Button>
      )}
    </>
  )
}

export default React.memo(AnonymousLinks)
